
<v-toolbar
    :class="{ dense: dense }"
    class="stat"
    :max-height="height"
    :height="height"
    :max-width="width"
    :width="width"
>
    <div class="stat-name" v-html="name"></div>
    <v-spacer></v-spacer>
    <div class="stat-count" v-text="count"></div>
</v-toolbar>
